"use client";

import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from "@tanstack/react-query";
import type { Message } from "ably";
import { useChannel } from "ably/react";
import Cookies from "js-cookie";
import { useCallback } from "react";
import { EVENT_USER_ROLE_REMOVED } from "@/constants/Ably/events";
import { useOrganization } from "@/hooks/useOrganization";
import { useTeamsContext } from "@/hooks/useTeamsContext";
import { isUsableUserChannelName } from "@/lib/ablyChannels";
import { useUserChannel } from "../UserChannelProvider";
interface RoleRemovedEventData {
  teamId?: string;
  scopeId?: string;
  teamName?: string;
  organizationId?: string;
  organizationName?: string;
}
const RoleChangeChannelSubscriber = t0 => {
  const $ = _c(8);
  const {
    channelName,
    children
  } = t0;
  const {
    currentTeamId
  } = useTeamsContext();
  const {
    currentOrganizationId
  } = useOrganization();
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== currentOrganizationId || $[1] !== currentTeamId || $[2] !== queryClient) {
    t1 = message => {
      const data = message.data as RoleRemovedEventData | undefined;
      if (data?.teamId) {
        if (currentTeamId === data.teamId) {
          Cookies.remove("x-team-id", {
            path: "/"
          });
          window.location.href = "/en/resolve?returnTo=files";
        } else {
          queryClient.invalidateQueries({
            predicate: _temp
          });
          queryClient.invalidateQueries({
            predicate: _temp2
          });
        }
      } else {
        if (data?.organizationId) {
          if (currentOrganizationId === data.organizationId) {
            window.location.href = "/en/resolve?returnTo=files";
          } else {
            queryClient.invalidateQueries({
              predicate: _temp3
            });
          }
        }
      }
    };
    $[0] = currentOrganizationId;
    $[1] = currentTeamId;
    $[2] = queryClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleRoleRemoved = t1;
  let t2;
  if ($[4] !== channelName) {
    t2 = {
      channelName,
      skip: false
    };
    $[4] = channelName;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useChannel(t2, EVENT_USER_ROLE_REMOVED, handleRoleRemoved);
  let t3;
  if ($[6] !== children) {
    t3 = <>{children}</>;
    $[6] = children;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export const RoleChangeSubscriber = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    channelName
  } = useUserChannel();
  if (!isUsableUserChannelName(channelName)) {
    let t1;
    if ($[0] !== children) {
      t1 = <>{children}</>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== channelName || $[3] !== children) {
    t1 = <RoleChangeChannelSubscriber channelName={channelName}>{children}</RoleChangeChannelSubscriber>;
    $[2] = channelName;
    $[3] = children;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function _temp(query) {
  const key = query.queryKey;
  return Array.isArray(key) && typeof key[0] === "object" && key[0] !== null && "url" in key[0] && String(key[0].url).includes("/teams");
}
function _temp2(query_0) {
  const key_0 = query_0.queryKey;
  return Array.isArray(key_0) && key_0[0] === "organizations" && key_0[1] === "infinite";
}
function _temp3(query_1) {
  const key_1 = query_1.queryKey;
  return Array.isArray(key_1) && key_1[0] === "organizations" && key_1[1] === "infinite";
}